import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, throwError, timeout} from 'rxjs';
@Component({
  selector: 'app-verify-email',
  imports: [],
  templateUrl: './verify-email.html',
  styleUrl: './verify-email.scss'
})
export class VerifyEmail {
  private apiUrl = environment.apiBaseUrl;

  loading = true;
  success = false;
  error = false;
  message = '';
  errorMessage = '';

  route = inject(ActivatedRoute)
  http = inject(HttpClient)
  router = inject(Router)

  redirectDelay = 4500; // 4 seconds

  constructor() {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (!token) {
        this.loading = false;
        this.error = true;
        this.errorMessage = 'No token provided in URL.';
        return;
      }

      this.http.get<{message: string}>(this.apiUrl + `/verify-email`, { params: { token } })
        .pipe(
          timeout(3000), // 5 seconds timeout
          catchError(err => {
            if (err.name === 'TimeoutError') {
              console.error('Request timed out');
            } else {
              console.error('Other error:', err);
            }
            return throwError(() => err); // or return of(fallbackValue) if you want to recover
          })
        )
        .subscribe({
          next: (res) => {
            this.loading = false;
            this.success = true;
            this.message = res.message || 'Email verified successfully!';
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.error = true;
            if (err.status === 400) {
              this.errorMessage = err.error.detail || 'Invalid or expired token.';
            } else {
              this.errorMessage = 'Oops, something went wrong.';
            }
          }
        });
    });
    setTimeout(() => {
      this.router.navigate(['/']); // Replace with your actual route
    }, this.redirectDelay);
  }
}
